module.exports = __webpack_public_path__ + "static/media/wood-texture_00015.55bc9958.jpg";